import axios from 'axios';
import { accessToken } from '@alli/frontend-common';

const centralApiHost = process.env.CENTRAL_API; // eslint-disable-line no-undef

export default function getClient(clientIdOrSlug) {
    const token = accessToken.getValue();
    if (!token) {
        // this should never happen...
        return Promise.reject(new Error('missing access token'));
    }

    const headers = {
        Authorization: token.authorizationHeader(),
        Accept: 'application/json',
    };

    return axios
        .get(`${centralApiHost}/clients/${clientIdOrSlug}`, { headers })
        .then(resp => resp.data);
}
